    /* globals vocento */
const app = Voonto.getInstance();
const SEL_WIDGET_COLLAPSE = '#commentsBlock';
const CLASS_COLLAPSE = 'collapse';
const EVENT_RECALC_STICKY = 'layout:recalc-sticky';
const REJECT_TIMEOUT = 20000;

//** Start Gigya Comments Widget *

function isCommentsLocation()
{
    var rst = false;
    var hashParams = document.location.hash.slice(1).split('&');
    for (let i = 0, n = hashParams.length; i < n; i++) {
        if (hashParams[i] === 'disqus_thread') {
            rst = true;
            break;
        }
    }
    return rst;
}

function expandWidget($commentTitle, $commentWidget, commentsBlock)
{
    var expanded = ($commentTitle.attr('aria-expanded') === 'true');
    if (!expanded) {
        Logger.debug('[comments] expand comments');
        commentsBlock.then(($commentsBlock) => {
            $commentsBlock.removeClass(CLASS_COLLAPSE);
            app.trigger(EVENT_RECALC_STICKY);
        });
        $commentTitle.attr('aria-expanded', 'true');
        // inview don't work in firefox. Trigger comments  widget load.
        $commentWidget.trigger('inview');
    }
}

function toogleWidget($commentTitle, $commentWidget, commentsBlock)
{
    var expanded = ($commentTitle.attr('aria-expanded') === 'true');
    if (expanded) {
        commentsBlock.then(($commentsBlock) => {
            $commentsBlock.addClass(CLASS_COLLAPSE);
            app.trigger(EVENT_RECALC_STICKY);
        });
        // inview don't work in firefox. Trigger comments  widget load.
    } else {
        commentsBlock.then(($commentsBlock) => {
            $commentsBlock.removeClass(CLASS_COLLAPSE);
            app.trigger(EVENT_RECALC_STICKY);
        });
    }
    $commentTitle.attr('aria-expanded', expanded ? 'false' : 'true');
    $commentWidget.trigger('inview');
}

function commentsInit()
{
    Logger.debug('[comments] commentsInit()');

    const commentsPath = app.lookup('vocento.config.nibara').commentsPath;
    if (commentsPath === undefined) {
        throw 'commentsPath path in config is empty';
    }

    var gigyaReady = new Voonto.RSVP.Promise(function (resolve, reject) {
        app.when('vocuser:gigyaready').then(function () {
            resolve(gigya);
        });
        setTimeout(function() {
            reject('timeout');
        }, REJECT_TIMEOUT);
    });

    var gigyaUx = new Voonto.RSVP.Promise(function (resolve, reject) {
        app.when('vocuser:ready').then(function (gigyaUX) {
            resolve(gigyaUX);
        });
        setTimeout(function() {
            reject('timeout');
        }, REJECT_TIMEOUT);
    });

    const commentBlock = new Voonto.RSVP.Promise((resolve, reject) => {
        app.one('vocuser:comments:load', function() {
            resolve(Voonto.$('#commentsBlock'));
            app.trigger(EVENT_RECALC_STICKY);
        });
    });

    const $commentCount = Voonto.$('.icono-comentarios');
    const $commentTitle = Voonto.$('.voc-comments-title.collapsed');
    var $commentWidget = Voonto.$('[data-voc-comments]');

    if (isCommentsLocation()) {
        Logger.debug('[comments] comments hash');
        expandWidget($commentTitle, $commentWidget, commentBlock);
    }

    $commentCount.on('click', function() {
        Logger.debug('[comments] click toolbar icon', this);
        expandWidget($commentTitle, $commentWidget, commentBlock);
    });

    $commentTitle.on('click', function() {
        Logger.debug('[comments] toogle comments', this);
        toogleWidget($commentTitle, $commentWidget, commentBlock);
    });

    app.one('vocuser:comments:error', function() {
        Logger.warning('[comments] comments widget error');
    });

    gigyaUx.then((gigyaUX) => {
        if ('anonimo' === gigyaUX.getUserType()) {
            $('<style>.gigya-logged-in{display:none !important;}</style>').appendTo(document.head);
        } else {
            $('<style>.gigya-logged-out{display:none !important;}</style>').appendTo(document.head);
        }
    }).catch(function(error) {
        Logger.warning('[comments] gigyaUx error: ' + error);
    });

    gigyaReady.then('vocuser:gigyaready').then(function () {
        app.load(commentsPath + '/comments.js');
    }).catch(function(error) {
        Logger.warning('[comments] gigya error: ' + error);
    });

}

//** End Gigya Comments Widget

export default commentsInit;



// WEBPACK FOOTER //
// ./src/scripts/article/gigya.js